import { Box, Tooltip } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";

const ResendIcon = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  return (
    <>
      <Tooltip title={props.toolTip ? t('ADD028') : ""}>
        <Box
          className={darkMode ? 'iconButton_dark' : 'iconButton'}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          {isHovered ?
            (
              <svg xmlns="http://www.w3.org/2000/svg" width="19.711" height="20" viewBox="0 0 19.711 20">
                <path id="Path_30575" data-name="Path 30575" d="M18.991,1.739a2.9,2.9,0,0,1,.753,1.389A2.74,2.74,0,0,1,19.628,4.7L14.639,19.1a2.894,2.894,0,0,1-.646.965,3.123,3.123,0,0,1-.434.357,2.76,2.76,0,0,1-1.621.463,2.8,2.8,0,0,1-2.586-1.93v-.116l-.6-3.638a1.65,1.65,0,0,1,.386-1.341l.733-.839,4.062-4.67a.969.969,0,1,0-1.37-1.371l-4.593,4-.8.695a1.63,1.63,0,0,1-1.351.376l-3.609-.646a2.9,2.9,0,0,1-1.505-.965,2.817,2.817,0,0,1-.145-3.3A2.73,2.73,0,0,1,1.923,6.06L16.067,1.053A2.827,2.827,0,0,1,19.02,1.7Z" transform="translate(-0.098 -0.883)" fill={darkMode ? '#fff' : '#474a4e'} />
              </svg>
            ) :
            (
              <svg xmlns="http://www.w3.org/2000/svg" width="19.766" height="20" viewBox="0 0 19.766 20">
                <path id="Path_30574" data-name="Path 30574" d="M17.465,1.932a1.214,1.214,0,0,0-.679.045l-.008,0L2.826,6.916A1.215,1.215,0,0,0,2.9,9.211l5.214.935.051.011a2.846,2.846,0,0,1,.717.282l3.994-3.994a.848.848,0,0,1,1.2,1.2l-4.028,4.028a2.846,2.846,0,0,1,.209.576q.008.032.013.064l.891,5.434a1.214,1.214,0,0,0,2.25.015L18.339,3.547l0-.013a1.214,1.214,0,0,0-.878-1.6ZM8.243,12.055a.854.854,0,0,0,.166.179,1.151,1.151,0,0,1,.189.389L9.5,18.1a.857.857,0,0,0,.034.136,2.91,2.91,0,0,0,5.459.137L15,18.336,19.939,4.109A2.91,2.91,0,0,0,16.208.382L2.253,5.32l-.014.005a2.911,2.911,0,0,0,.233,5.529q.039.011.08.018l5.23.938A1.151,1.151,0,0,1,8.243,12.055Z" transform="translate(-0.348 -0.207)" fill={darkMode ? '#fff' : '#474a4e'} fill-rule="evenodd" opacity="0.8" />
              </svg>
            )
          }
        </Box>
      </Tooltip>
    </>
  )
}
export default ResendIcon
